module.exports = __webpack_public_path__ + "img/mn.f73bd8d.svg";